import styled from 'styled-components';

const DivCategoryButton = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export default DivCategoryButton;
